#@import GliveBooking.Views.Price
#@export GliveBooking.Views.Prices

class GliveBooking.Views.Prices extends BookingV2.Views.Collection

  module: 'glive-booking'

  tagName: 'ul'

  childView: GliveBooking.Views.Price

  attributes:
    'data-bhc': 'booking:sections'

  constructor: ->
    BookingV2.Views.Collection.apply this, arguments
    @on 'select', @select, this

  select: (section) ->
    @options.selected = section
    @render()
